<template>
  <section class="compare">
    <div class="center">
      <h3>{{obj.title}}</h3>
      <div class="content">
        <div class="lf dv" v-for="(item, i) in obj.list" :key="i">
          <h6 :class="[type === 1 ? '' : 'hclass']">{{item.t}}</h6>
          <p>{{item.val}}</p>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'Compare',
  props: {
    type: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      compareObj: [
        {
          title: '福利助手与传统福利对比',
          list: [
            { t: '传统福利弊端', val: '福利发放问题多、消费使用途径少、员工参与度低。' },
            { t: '福利助手平台优势', val: '采购价格优势大、全数字化积分兑换、覆盖生活全场景。' }
          ]
        },
        {
          title: '福利助手的体检优势',
          list: [
            { t: '传统员工体检弊端', val: '体检机构良莠不齐、套餐定制专业不足、员工体检结果分散、企业健康投入成本高。' },
            { t: '福利助手优势', val: '强势公立医院核心资源、专业定制化体检套餐、体检价格全网最低、一站式员工健康管理。' }
          ]
        }
      ]
    }
  },
  computed: {
    obj: function() {
      return this.compareObj[this.type - 1];
    }
  }
}
</script>
<style scoped lang="less">
.compare {
  height: 391px;
  width: 100%;
  .center {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    overflow: hidden;
    h3 {
      font-size:30px;
      font-family: @PingFangSC-Semibold;
      font-weight:600;
      color:@text-color;
      line-height:42px;
      margin: 58px 0px;
      text-align: center;
    }
    .content {
      width: 100%;
      overflow: hidden;
      .dv {
        width: 50%;
        height: 134px;
        color: @white;
        text-align: center;
        h6 {
          font-size:24px;
          font-family: @PingFangSC-Semibold;
          font-weight:600;
          line-height:33px;
          margin-top: 29px;
          margin-bottom: 10px;
        }
        .hclass {
          margin-top: 23px;
          margin-bottom: 3px;
        }
        p {
          font-size:18px;
          font-family: @PingFangSC-Regular;
          font-weight:400;
          line-height:25px;
          width: 450px;
          margin: 0px auto;
        }
      }
      .dv:nth-child(1) {
        background: url('@{image}/compare1.png') no-repeat center center / 100% 100%;
      }
      .dv:nth-child(2) {
        background: url('@{image}/compare2.png') no-repeat center center / 100% 100%;
      }
    }
  }
}
</style>
